export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      contractorDetails = {},
      propertyDetails = {},
      systemOverview = {},
      preFlushAssessment = {},
      flushingProcess = {},
      postFlushVerification = {},
      declarations = {}
    } = formData;

    if (!contractorDetails.companyName?.trim()) {
      errors['contractorDetails.companyName'] = 'Company name is required';
    }
    if (!contractorDetails.engineerName?.trim()) {
      errors['contractorDetails.engineerName'] = 'Engineer name is required';
    }
    if (!propertyDetails.clientName?.trim()) {
      errors['propertyDetails.clientName'] = 'Client name is required';
    }
    if (!propertyDetails.propertyAddress?.trim()) {
      errors['propertyDetails.propertyAddress'] = 'Property address is required';
    }
    if (!systemOverview.boilerMakeModel?.trim()) {
      errors['systemOverview.boilerMakeModel'] = 'Boiler / heat source model is required';
    }

    // TDS Benchmark Check (BS 7593 recommends final TDS within 10% of mains water TDS)
    const mainsTds = Number(preFlushAssessment.mainsWaterTdsPpm) || 0;
    const finalTds = Number(postFlushVerification.postFlushTdsPpm) || 0;
    if (mainsTds > 0 && finalTds > 0) {
      const diffPct = Math.abs(((finalTds - mainsTds) / mainsTds) * 100);
      if (diffPct > 10) {
        warnings['postFlushVerification.postFlushTdsPpm'] = 
          `Final TDS (${finalTds} ppm) differs by ${diffPct.toFixed(1)}% from incoming mains (${mainsTds} ppm). BS 7593 recommends within 10%.`;
      }
    }

    const finalPh = Number(postFlushVerification.postFlushPh);
    if (finalPh && (finalPh < 6.5 || finalPh > 8.5)) {
      warnings['postFlushVerification.postFlushPh'] = `Final pH of ${finalPh} is outside optimal range (6.5 - 8.5).`;
    }

    if (!declarations.engineerSignature) {
      errors['declarations.engineerSignature'] = 'Engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
